import React from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'ddc-track-event';
import { setClassNames } from 'ddc-classnames-js';
import { usePrefs, useLabels, useRequestData } from 'wsm-common-data';

import { ModelImage } from '../ModelImage';
import { getModelTitle } from '../../utils/getModelTitle';
import { getFormattedPrice } from '../../utils/getFormattedPrice';

const GridCard = ({ modelObject, modelLink }) => {
	const prefs = usePrefs();
	const labels = useLabels();
	const { locale, widgetName, windowId } = useRequestData();

	const { image, inventoryCount } = modelObject;
	const {
		showInventoryOnLotCount,
		modelTitleAttributes,
		inventoryCountLabel,
		startingAtPriceLabel
	} = prefs;

	const showInventoryCount = showInventoryOnLotCount === 'true';
	const modelClassNames = [
		'model',
		showInventoryCount ? 'showing-count' : null,
		'p-6'
	];
	const modelTitleClassName = [
		'font-weight-bold',
		'ddc-font-size-large',
		'justify-content-start'
	];
	const priceClassNames = [
		'price',
		'ddc-font-size-small',
		'inline-block',
		'justify-content-start',
		'd-flex'
	];
	const modelTitle = getModelTitle(modelTitleAttributes, modelObject);
	const formattedPrice = getFormattedPrice(locale, modelObject);

	const trackClick = () => {
		trackEvent(widgetName, windowId, {
			action: 'clicked',
			element: 'Model Image',
			elementCTA: modelTitle,
			result: 'Navigated to model listings'
		});
	};

	return (
		<div className="model-card box box-border d-flex flex-column position-relative">
			<div className={setClassNames(modelClassNames)}>
				<div className=" model-card-grid-title-container d-flex flex-column">
					<span className={setClassNames(modelTitleClassName)}>
						{modelTitle}
					</span>
					<span className={setClassNames(priceClassNames)}>
						{`${labels.get(startingAtPriceLabel)} `}{' '}
						{formattedPrice}
					</span>
				</div>

				<a
					href={modelLink}
					onClick={trackClick}
					className="image-container py-9"
					data-testid="model-card-grid-component-test"
				>
					<ModelImage url={image} altImage={modelTitle} />
				</a>

				<span className="font-weight-extended-bold ddc-font-size-small text-center">
					{showInventoryCount && (
						<div className="touch-inventory-count ddc-font-size-xsmall font-weight-bold">
							{inventoryCount}
							<span className="inventory-count-label">
								{` ${labels.get(inventoryCountLabel)}`}
							</span>
						</div>
					)}
				</span>
			</div>
		</div>
	);
};

GridCard.propTypes = {
	modelObject: PropTypes.shape({
		year: PropTypes.number,
		make: PropTypes.string,
		model: PropTypes.string,
		image: PropTypes.string,
		inventoryCount: PropTypes.number,
		minStartingAtPrice: PropTypes.number
	}).isRequired,
	modelLink: PropTypes.string.isRequired
};

export default GridCard;
